import React from 'react';
import { CloseHamburgerMenu } from '@yme/assets/icons';
import { ControlPanelStyled } from '@yme/atoms/autocomplete-request/styled';
import { Button, ICON_ONLY, SIZE_36, TEXT_VARIANT } from '@yme/atoms/button';
export function ControlPanel({ isRightToLeft, onClick, isVisible }) {
    return (React.createElement(ControlPanelStyled, { isVisible: isVisible, isRightToLeft: isRightToLeft },
        React.createElement(Button, { onClick: onClick, buttonVariant: TEXT_VARIANT, hasIconButton: ICON_ONLY, size: SIZE_36, iconComponent: CloseHamburgerMenu })));
}
